<template>
  <div class="bg_content">
    <div class="device_head">
      <span style="color: #b2b2b2">访客管理 /</span>
      <span style="color: #5c5c5c"> 访客申请</span>
    </div>
    <div class="content_body">
      <el-card class="visitor_card_table" shadow="never">
        <div class="wait">
          <div class="wait_header">
            <el-radio-group
                v-model="searchQuery.status"
                class="wait_header_tablist"
            >
              <div class="wait_header_tab" v-for="(item,index) in statusList" :key="index">
                <el-badge class="item" :value="item.count" :max="99" :hidden="item.count == 0">
                  <el-radio-button :label="item.value">{{ item.label }}</el-radio-button>
                </el-badge>
              </div>
            </el-radio-group>
            <div class="wait_search">

                <el-popover
                    placement="bottom"
                    width="auto"
                    popper-class="visitor_qrcode_popover"
                    trigger="hover">
                  <div style="display: flex;justify-content: center;width: 100%;padding: 15px 0;">
                    <div class="flex-container">
                      <div class="centered-box">
                        <div class="centered-text" style="margin: 5px 0;font-weight: bold">「 企业邀约码 」</div>
                        <div class="img">
                          <img v-if="qrcodeForm.companyQrcode" :src="`data:image/png;base64,${qrcodeForm.companyQrcode}`">
                          <span v-else>生成邀约码失败</span>
                        </div>
                        <el-button v-if="qrcodeForm.companyQrcode" type="primary" size="small" style="margin-top: 3px;"
                        @click="downloadCompanyQrCode(`data:image/png;base64,${qrcodeForm.companyQrcode}`,'企业邀约码')">下载邀约码</el-button>
                      </div>
                    </div>

                    <div class="flex-container" style="margin-left: 30px;">
                      <div class="centered-box">
                        <div class="centered-text" style="margin: 5px 0;font-weight: bold">「 企业员工邀约码 」</div>
                        <div class="img">
                          <img v-if="qrcodeForm.memberQrcode" :src="`data:image/png;base64,${qrcodeForm.memberQrcode}`">
                          <span v-else>生成邀约码失败</span>
                        </div>
                        <el-button v-if="qrcodeForm.memberQrcode" type="primary" size="small" style="margin-top: 3px;"
                        @click="downloadCompanyQrCode(`data:image/png;base64,${qrcodeForm.memberQrcode}`,'企业员工邀约码')">下载邀约码</el-button>
                      </div>
                    </div>
                  </div>
                  <div slot="reference">
                    <div  class="visitor_qrcode_but">
                      <svg t="1769759494670" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5944" width="20" height="20"><path d="M829.64898 472.293878h-198.530613c-43.885714 0-79.412245-35.526531-79.412245-79.412245v-198.530613c0-43.885714 35.526531-79.412245 79.412245-79.412244h198.530613c43.885714 0 79.412245 35.526531 79.412244 79.412244v198.530613c0 43.885714-35.526531 79.412245-79.412244 79.412245zM392.881633 472.293878h-198.530613c-43.885714 0-79.412245-35.526531-79.412244-79.412245v-198.530613C114.938776 150.465306 150.465306 114.938776 194.35102 114.938776h198.530613c43.885714 0 79.412245 35.526531 79.412245 79.412244v198.530613c0 43.885714-35.526531 79.412245-79.412245 79.412245zM392.881633 909.061224h-198.530613c-43.885714 0-79.412245-35.526531-79.412244-79.412244v-198.530613c0-43.885714 35.526531-79.412245 79.412244-79.412245h198.530613c43.885714 0 79.412245 35.526531 79.412245 79.412245v198.530613c0 43.885714-35.526531 79.412245-79.412245 79.412244z" fill="#568289" p-id="5945"></path><path d="M194.35102 591.412245c-21.942857 0-39.706122 17.763265-39.706122 39.706122v198.530613c0 21.942857 17.763265 39.706122 39.706122 39.706122h198.530613c21.942857 0 39.706122-17.763265 39.706122-39.706122v-198.530613c0-21.942857-17.763265-39.706122-39.706122-39.706122h-198.530613zM194.35102 154.644898c-21.942857 0-39.706122 17.763265-39.706122 39.706122v198.530613c0 21.942857 17.763265 39.706122 39.706122 39.706122h198.530613c21.942857 0 39.706122-17.763265 39.706122-39.706122v-198.530613c0-21.942857-17.763265-39.706122-39.706122-39.706122h-198.530613zM631.118367 154.644898c-21.942857 0-39.706122 17.763265-39.706122 39.706122v198.530613c0 21.942857 17.763265 39.706122 39.706122 39.706122h198.530613c21.942857 0 39.706122-17.763265 39.706122-39.706122v-198.530613c0-21.942857-17.763265-39.706122-39.706122-39.706122h-198.530613z" fill="#E4F2F2" p-id="5946"></path><path d="M758.595918 353.17551h-56.424489c-17.240816 0-31.346939-14.106122-31.346939-31.346939V265.404082c0-17.240816 14.106122-31.346939 31.346939-31.346939h56.424489c17.240816 0 31.346939 14.106122 31.346939 31.346939v56.424489c0 17.240816-14.106122 31.346939-31.346939 31.346939zM321.828571 353.17551H265.404082c-17.240816 0-31.346939-14.106122-31.346939-31.346939V265.404082c0-17.240816 14.106122-31.346939 31.346939-31.346939h56.424489c17.240816 0 31.346939 14.106122 31.346939 31.346939v56.424489c0 17.240816-14.106122 31.346939-31.346939 31.346939zM321.828571 789.942857H265.404082c-17.240816 0-31.346939-14.106122-31.346939-31.346939v-56.424489c0-17.240816 14.106122-31.346939 31.346939-31.346939h56.424489c17.240816 0 31.346939 14.106122 31.346939 31.346939v56.424489c0 17.240816-14.106122 31.346939-31.346939 31.346939z" fill="#245156" p-id="5947"></path><path d="M571.559184 909.061224c-10.971429 0-19.853061-8.881633-19.853062-19.853061v-258.089796c0-43.885714 35.526531-79.412245 79.412245-79.412245h39.706123c43.885714 0 79.412245 35.526531 79.412245 79.412245v59.559184c0 21.942857 17.763265 39.706122 39.706122 39.706122h39.706123c21.942857 0 39.706122-17.763265 39.706122-39.706122v-119.118367c0-10.971429 8.881633-19.853061 19.853061-19.853062 10.971429 0 19.853061 8.881633 19.853061 19.853062v119.118367c0 43.885714-35.526531 79.412245-79.412244 79.412245h-39.706123c-43.885714 0-79.412245-35.526531-79.412245-79.412245v-59.559184c0-21.942857-17.763265-39.706122-39.706122-39.706122h-39.706123c-21.942857 0-39.706122 17.763265-39.706122 39.706122v258.089796c0 10.971429-8.881633 19.853061-19.853061 19.853061zM889.208163 909.061224h-158.82449c-10.971429 0-19.853061-8.881633-19.853061-19.853061 0-10.971429 8.881633-19.853061 19.853061-19.853061h158.82449c10.971429 0 19.853061 8.881633 19.853061 19.853061 0 10.971429-8.881633 19.853061-19.853061 19.853061z" fill="#568289" p-id="5948"></path></svg>
                      <span>访客邀约码</span>
                    </div>
                  </div>
                </el-popover>

                <el-input placeholder="访客姓名" v-model="searchQuery.visitor" clearable></el-input>
                <el-input placeholder="访客手机号" v-model="searchQuery.phoneNum" clearable style="margin-left: 10px"></el-input>
                <div>
                  <el-date-picker v-model="timerange"
                                  format="yyyy-MM-dd"
                                  value-format="yyyy-MM-dd"
                                  type="daterange" :clearable="false"
                                  :picker-options="pickerOptions"
                                  style="margin-left: 10px"
                                  range-separator="至" start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </div>
                <el-button type="primary" icon="el-icon-search" @click="handleSearch" style="margin-left: 10px">搜索</el-button>
                <el-button type="primary" icon="el-icon-hot-water" @click="handleInvite" style="margin-left: 10px">新建邀约</el-button>
<!--                <el-button type="danger" icon="el-icon-delete" @click="handleBatchDelete"
                           :disabled="!(multipleSelection && multipleSelection.length>0)"
                           v-if="searchQuery.status === 2 || searchQuery.status === 4"
                           style="margin-left: 10px">批量删除</el-button>-->
            </div>
          </div>
        </div>
        <el-table :data="tableData" :header-cell-style="{background: '#F5F6FA',color: '#5C5C5C',}" height="580"
                  @selection-change="handleSelectionChange">
          <template slot="empty">
            <div>
              <img src="@/assets/nodata.png" class="nodata" />
              <div>无数据</div>
            </div>
          </template>
<!--          <el-table-column
              type="selection"
              width="55">
          </el-table-column>-->
          <el-table-column label="访客姓名" prop="visitor" min-width="100">
            <template slot-scope="scope">
              <div style="display: flex;justify-content: start;align-items: center">
                <div>
                  <el-image v-if="scope.row.photoBase64"
                            style="width: 26px; height: 26px;border-radius: 50%;margin-right: 5px;"
                            :src="'data:image/jpeg;base64,'+scope.row.photoBase64"
                            :preview-src-list="['data:image/jpeg;base64,'+scope.row.photoBase64]">
                  </el-image>
                  <div v-else style="display: flex;justify-content: center;align-items: center; width: 26px;height: 26px;border-radius: 50%;margin-right: 5px;background: #b1b0b0;">
                    <i class="el-icon-user" style="font-size: 18px;color: #fff;"></i>
                  </div>
                </div>
                <div class="table_scope_t">{{ scope.row.visitor }}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="性别" prop="sex" align="center" width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.sex" class="table_scope_t">{{ scope.row.sex }}</div>
              <span v-else class="table_scope_f">未知</span>
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="phoneNum"></el-table-column>
          <el-table-column label="类型" prop="type" align="center" width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.type == 1" class="table_scope_t">自助预约</div>
              <span v-else class="table_scope_f">员工邀约</span>
            </template>
          </el-table-column>
          <el-table-column label="车牌号" prop="plateNum"></el-table-column>
          <el-table-column label="访问时间" prop="visitDate" align="center"></el-table-column>
          <el-table-column label="预计离访时间" prop="visitEndDate"  align="center"></el-table-column>
          <el-table-column label="随行人数" prop="personCnt"></el-table-column>
          <el-table-column label="访问原因" prop="reason"></el-table-column>
          <el-table-column label="被访人" prop="user">
            <template slot-scope="scope">
              <div v-if="scope.row.user" class="table_scope_t">{{ scope.row.user?.name }}</div>
              <span v-else class="table_scope_f">-</span>
            </template>
          </el-table-column>
          <el-table-column label="拒绝原因" prop="rejectReason" v-if="searchQuery.status === 2"></el-table-column>
          <el-table-column label="设备编号" prop="deviceNumber" v-if="searchQuery.status === 1 || searchQuery.status === 3 || searchQuery.status === 4">
            <template slot-scope="{row}">
              <div>{{ row.deviceNumber || '-' }}</div>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
          <el-table-column label="操作" width="190">
            <template slot-scope="{row}">
              <el-link type="primary" style="margin-right: 15px;" @click="handleDetail(row)">详情</el-link>
              <el-link v-if="row.status === 0" type="primary" style="margin-right: 15px;" @click="handleAudit(row)">审核</el-link>
              <el-link v-if="row.status === 1" type="primary" style="margin-right: 15px;" @click="handleConfirm(row)">确认到访</el-link>
              <el-link v-if="row.status === 3" type="warning" style="margin-right: 15px;" @click="handleLeave(row)">离访</el-link>
<!--              <el-popconfirm
                  title="确定删除该访客信息吗？"
                  @confirm="handleDelete(row)"
              >
                <el-link slot="reference" v-if="row.status == 2 || row.status == 4" type="danger">删除</el-link>
              </el-popconfirm>-->

              <el-popover
                  placement="bottom"
                  width="320"
                  :show="generateMemberQrCode(row.qrcode,`canvas_${row.id}`)"
                  popper-class="visitor_qrcode_popover"
                  trigger="hover">
                <div style="width: 100%;padding: 10px 0;text-align: center">
                  <div style="display: inline-block; margin: 0 auto;text-align: center">
                    <div style="margin: 5px 0;font-weight: bold;color:#fff;font-size: 16px;">「 访客码 」</div>
                    <div style="width: 100%;text-align: center;border-radius: 5px;padding: 5px;background: #fff">
                      <canvas :ref="`canvas_${row.id}`" :id="`canvas_${row.id}`"></canvas>
                    </div>
                    <div class="menber-download-qrcode" @click="download(row.visitor,`canvas_${row.id}`)">下载访客码</div>
                  </div>
                </div>
                <el-link slot="reference" type="primary" v-show="row.qrcode">访客码</el-link>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
        <div style="display: flex;justify-content: space-between;margin-top: 10px;">
          <el-alert  title="仅展示近6个月数据" type="warning" :closable="false" center style="width: auto;width:130px;"></el-alert>
          <el-pagination v-model:current-page="searchQuery.pageNum" :page-size="searchQuery.pageSize"
                         layout="total, ->, prev, pager, next" :total="tableTotal" @current-change="handleCurrentChange" />
        </div>
      </el-card>
    </div>
    <company-footer-info />

    <!-- 审核弹窗 --->
    <Audit ref="auditRef" @success="handleSearch"/>
    <Detail ref="detailRef"/>
    <Invite ref="inviteRef" @success="handleSearch"/>
  </div>
</template>

<script>
import QRCode from "qrcode";
import CompanyFooterInfo from "@/components/companyFooterInfo.vue";
import {VisitorApplyApi} from '@/api/server/visitorApply';
import Detail from "@/views/visitor/detail.vue";
import Audit from "@/views/visitor/audit.vue";
import Invite from "@/views/visitor/invite.vue";
import logo from '@/assets/visitor/comte.png';
import dayjs from "dayjs";
export default {
  components: {
    CompanyFooterInfo,
    Audit,
    Detail,
    Invite
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          // return time.getTime() > Date.now();
          let today = new Date();
          today.setMonth(today.getMonth() - 6);
          return time.getTime() < today.getTime(); //如果没有后面的-8.64e7就是不可以选择今天的
        },
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      timerange: [new Date(new Date().getTime() - 3600 * 1000 * 24 * 7), new Date()],
      logoUrl: logo,
      qrcodeForm:{},
      statusList:[
        {value: 1, label: '待访问', key: 'waitVisit'},
        // {value: 2, label: '已拒绝', key: 'rejected'},
        {value: 3, label: '访问中', key: 'visiting'},
        {value: 4, label: '已结束', key: 'finished'},
      ],
      //查询条件
      searchQuery: {
        status: this.$route.params.status || 1,
        visitor:'',
        phoneNum:'',
        pageSize: 20,
        pageNum: 1,
      },
      //表格数据
      tableData: [],
      tableTotal: 0,
      multipleSelection:[]
    }
  },
  watch: {
    'searchQuery.status'(val) {
      this.handleSearch();
    }
  },
  methods: {
    handleSearch() {
      if (!(this.timerange && this.timerange.length >= 2)) {
        this.$message.error("请选择时间")
        return;
      }
      this.searchQuery.startTime = this.timerange[0] ? dayjs(this.timerange[0]).format('YYYY-MM-DD') : '';
      this.searchQuery.endTime = this.timerange[1] ? dayjs(this.timerange[1]).format('YYYY-MM-DD') : '';
      VisitorApplyApi.selectVisitorPage(this.searchQuery).then(response => {
        const {code,data} = response;
        if(code == 200){
          const {total, list} = data;
          this.tableTotal = total;
          this.tableData = list;
        }
      });
      this.selectUmsVisitorApplyStatusCount({startTime: this.searchQuery.startTime, endTime: this.searchQuery.endTime});
    },
    handleInvite(){
      this.$refs.inviteRef.show();
    },
    selectUmsVisitorApplyStatusCount(data){
      VisitorApplyApi.selectUmsVisitorApplyStatusCount(data).then(response => {
        const {code,data} = response;
        if(code == 200){
          this.statusList.forEach(item => {
            // item.count = data[item.key] || 0;
            this.$set(item, "count", data[item.key] || 0)
          })
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleCurrentChange(page) {
      this.searchQuery.pageNum = page;
      this.handleSearch();
    },
    handleDetail(row){
      this.$refs?.detailRef?.show(row);
    },
    handleAudit(row){
      this.$refs.auditRef.show(row);
    },
    handleConfirm(row){
      this.$confirm('您确定该访客已到访？').then(() => {
        VisitorApplyApi.confirmApproval({id: row.id}).then(response => {
          const {code,data} = response;
          if(code == 200){
            this.$message.success('确认成功');
            this.handleSearch();
          }
        })
      }).catch(() => {})
    },
    handleLeave( row){
      this.$confirm('您确定该访客已离开？').then(() => {
        VisitorApplyApi.leaveVisit({id: row.id}).then(response => {
          const {code,data} = response;
          if(code == 200){
            this.$message.success('离访成功');
            this.handleSearch();
          }
        })
      }).catch(() => {})
    },
    handleDelete(row){
      VisitorApplyApi.deleteApply(row.id).then(response => {
        const {code,data} = response;
        if(code == 200){
          this.$message.success('删除成功');
          this.handleSearch();
        }
      })
    },
    handleBatchDelete(){
      this.$confirm('您确定要批量删除访客信息吗？').then(() => {
        let ids = [];
        this.multipleSelection.forEach(item => {
          ids.push(item.id);
        })
        VisitorApplyApi.batchDeleteApply({ids:ids}).then(response => {
          const {code,data} = response;
          if(code == 200){
            this.$message.success('删除成功');
            this.handleSearch();
          }
        })
      }).catch(() => {})
    },
    generateQrcode(){
      VisitorApplyApi.generateQrcode().then(response => {
        const {code,data} = response;
        if(code == 200){
          this.qrcodeForm = data || {};
        }
      })
    },
    async generateMemberQrCode(text,id) {
      if(text){
        this.$nextTick(async() => {
          try {
            const qrSize = 240; // QR Code 的尺寸
            const qrDataUrl = await QRCode.toDataURL((text), {
              width: qrSize,
              height: qrSize,
              margin: 1,
              errorCorrectionLevel: 'H'
            });
            const canvas = this.$refs[id];
            const ctx = canvas.getContext('2d');

            canvas.width = qrSize;
            canvas.height = qrSize;
            // 绘制二维码
            const img = new Image();
            img.src = qrDataUrl;
            img.onload = () => {
              ctx.drawImage(img, 0, 0, qrSize, qrSize);
              // 清理 logo 周围的区域
              const centerX = qrSize / 2;
              const centerY = qrSize / 2;
              ctx.globalCompositeOperation = 'destination-out'; // 设置为擦除模式
              ctx.beginPath();
              ctx.arc(centerX, centerY, 0, 0, Math.PI * 2); // 清理圆区域
              ctx.fill();
              ctx.globalCompositeOperation = 'source-over'; // 恢复正常模式
              // 绘制 logo
              const logo = new Image();
              logo.src = this.logoUrl;
              logo.onload = () => {
                const logoSize = qrSize / 5; // logo 的尺寸
                const logoX = centerX - logoSize / 2; // logo 的 X 坐标
                const logoY = centerY - logoSize / 2; // logo 的 Y 坐标
                ctx.drawImage(logo, logoX, logoY, logoSize, logoSize);
              };
            };
          } catch (err) {
            console.error('Error generating QR code:', err);
          }
        })
      }
    },
    download(name,id) {
      const filename = `${name}访客二维码`;
      const image = this.$refs[id]?.toDataURL('image/png').replace('image/png', 'image/octet-stream'); // 将PNG转换为octet-stream以触发下载
      const link = document.createElement('a');
      link.href = image;
      link.download = `${filename}.png`; // 设置下载的文件名
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link); // 清理DOM
    },
    base64ToBlob(base64Str, contentType, sliceSize) {
      contentType = contentType || ''
      sliceSize = sliceSize || 512
      const byteCharacters = atob(base64Str.split(',')[1])
      const byteArrays = []
      for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize)
        const byteNumbers = new Array(slice.length)
        for (let i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }
        const byteArray = new Uint8Array(byteNumbers)
        byteArrays.push(byteArray)
      }
      const blob = new Blob(byteArrays, { type: contentType })
      return blob
    },
    downloadCompanyQrCode(img,filename) {
      const blob = this.base64ToBlob(img, 'image/png')
      const url = URL.createObjectURL(blob)

      const link = document.createElement('a')
      link.href = url
      link.download = filename;
      document.body.appendChild(link)
      link.click()
      // 清理
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }
  },
  mounted() {
    let invite = this.$route?.params?.invite;
    if(invite === 1){
      this.handleInvite();
    }
    this.generateQrcode();
    this.handleSearch();
  }
}
</script>

<style scoped>
.bg_content {
  width: 100%;
  padding: 16px 20px;
  background: #f4f7fc;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.content_body {
  margin-top: 20px;
  height: 100%;
}

.table_scope_t {
  color: #4192F3;
}

.table_scope_f {
  color: #EE7B32;
}

.time_single {
  flex: 0 0 116px;
  /* 不伸缩，基准宽度 116px */
  width: 100px;
  /* 实际宽度 100px */
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 16px;
  color: #1a1a1a;
  background: #dee4ed;
  border-radius: 4px;
  margin-right: 8px;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;

}

.visitor_card_table {
  height: calc(100%) !important;
}

.search-icon {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}
.wait {
  width: 100%;
  height: 100%;
  padding: 5px 5px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: white;
}
.wait_header {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  align-items: center;
  justify-content: space-between;
}
.wait_header_tablist {
  display: flex;
  align-items: center;
}
.wait_header_tab {
  margin-right: 14px;
}
/* ::v-deep .el-radio-button {
  margin-right: 14px;
} */
::v-deep .el-radio-button__inner {
  border: 1px solid #d0d0d0;
  font-size: 15px;
  border-radius: 6px;
  color: #1a1a1a;
}
::v-deep .el-radio-button:last-child .el-radio-button__inner,
.el-radio-button:first-child .el-radio-button__inner {
  border-radius: 6px;
}
::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #1E40AF;
  color: white;
  border-color: #1E40AF;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 6px;
}
.visitor_information_search {
  width: 243px;
  height: 36px;
  border-radius: 4px;
  border: 1px solid #d0d0d0;
  display: flex;
  align-items: center;
  padding-right: 12px;
  box-sizing: border-box;
  justify-content: space-between;
}
.wait_search {
  display: flex;
  align-items: center;
}
::v-deep .el-select {
  width: 200px;
  height: 36px;
  margin-left: 10px;
}
::v-deep .el-select .el-input__inner {
  height: 36px;
}
.export_table {
  width: 80px;
  height: 36px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #d5d7e3;
  font-size: 14px;
  color: #7e84a3;
  line-height: 36px;
  text-align: center;
  cursor: pointer;
  margin-left: 10px;
}
::v-deep .el-range-editor.el-input__inner {
  width: 300px;
  height: 36px;
  margin-right: 10px;
}
::v-deep .wait_search .el-date-editor .el-range-separator {
  line-height: 28px;
}
::v-deep .el-select-dropdown__item {
  padding: 0;
}
.wait_approve {
  flex: 1;
}
.visitor_qrcode_but{
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10rem;
  font-size: 16px;
  border: 1px solid #409EFF;
  border-radius: 5px;
  padding: 6px;
  margin-right: 15px;
  background: rgb(64,158,255,0.1);
  cursor: pointer;
}
.visitor_qrcode_but span{
  margin-left: 10px;
}
.flex-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.centered-box {
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.3);
  background: #fff;
  /*border: 1px solid #DCDFE6;*/
  text-align: center;
  width: 320px;
  height: 320px;
}
.flex-container .centered-box .img{
  width: 235px;
  height: 235px;
  border-radius: 12px;
  border: 1px solid #ebeef5;
  padding: 10px;
  text-align: center;
  display: inline-block; /* 或 display: block; 然后使用 margin: 0 auto; */
  margin: 0 auto;
}
.flex-container .centered-box .img span{
  line-height: 180px;
  color: #e35d5d;
}
.flex-container .centered-box .img img{
  width: 100%;
  height: 100%;

}
.flex-container .centered-box .centered-text{
  font-size: 16px;
}
.menber-download-qrcode{
  margin: 0 auto;
  margin-top: 15px;
  width: 100px;
  height: 24px;
  border-radius: 3px;
  background: #fff;
  color: black;
  display: flex;
  padding: 4px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
</style>

<style>
.visitor_qrcode_popover{
  border: 1px solid #1E40AF!important;
  background: #1E40AF !important;
  padding: 10px 30px!important;
}
.visitor_qrcode_popover .popper__arrow::after {
  border-bottom-color: #1E40AF!important;
}
</style>